<div id="firing-history-main">
  <div id="firings-list">
    <h6 *ngIf="!small_screen">{{ 'FIRING_HISTORY.CHOOSE_A_FIRING' | translate }}</h6>
    <ion-progress-bar *ngIf="(retrieving && !selected_firing) || retrieving_more" type="indeterminate"></ion-progress-bar>
     <ion-list *ngIf="!viewingKilnlinkFreeKilns && (firing_history && firing_history.length > 0) && !small_screen" id="firing-history-list">
       <ion-item *ngFor="let firing of firing_history" class="firing ion-text-wrap"
        (click)="selectFiring(firing.id)"
        [class.selected]="selected_firing === firing.id"
        [color]="selected_firing === firing.id ? 'tertiary' : 'light'"
      >
        <ion-label>{{firing.started | date:'mediumDate' }}</ion-label>
        <ion-label class="program-name ion-text-wrap" *ngIf="firing.name">({{firing.name}})</ion-label>
       </ion-item>
       <ion-item class="load-more" color="primary" *ngIf="canLoadMore && !retrieving_more" (click)="getMoreFiringHistory()">{{ 'FIRING_HISTORY.LOAD_MORE' | translate }}</ion-item>
       <ion-item class="loading-more" *ngIf="retrieving_more">{{ 'FIRING_HISTORY.RETRIEVING_MORE_FIRINGS' | translate }}</ion-item>
     </ion-list>
     <ion-list *ngIf="viewingKilnlinkFreeKilns" id="firing-history-list">
       <ion-item class="firing">
        {{ 'FIRING_HISTORY.FIRING_HISTORY_NOT_AVAILABLE' | translate }}
       </ion-item>
     </ion-list>
    <ion-item *ngIf="small_screen" class="ion-text-wrap">
      <ion-label class="program-name" *ngIf="details">{{details.createdAt | date:'mediumDate'}} - {{details && details.program ? details.program.name : ('FIRING_HISTORY.NAME_NA' | translate)}}</ion-label>
      <ion-button (click)="showPicker()" *ngIf="!viewingKilnlinkFreeKilns && (firing_history && firing_history.length > 0) && small_screen">{{ 'FIRING_HISTORY.CHOOSE' | translate }}</ion-button>
    </ion-item>
    <div *ngIf="!retrieving && !viewingKilnlinkFreeKilns && !error && (firing_history && firing_history.length == 0)">{{ 'FIRING_HISTORY.NO_FIRING_HISTORY' | translate }}</div>
  </div>

  <div id="historical-firing-details" *ngIf="viewingKilnlinkFreeKilns">
    <!--  <ion-list class="tabs" *ngIf="!small_screen">
       <ion-item (click)="subtab = 'program'" [class.current]="subtab == 'program'">Program </ion-item>
       <ion-item (click)="getFiringStatuses('results-graph')" [class.current]="subtab == 'results-graph'">Results Graph </ion-item>
       <ion-item (click)="getFiringStatuses('firing-data')" [class.current]="subtab == 'firing-data'">Firing Data </ion-item>
       <ion-item (click)="subtab = 'firing-notes'" [class.current]="subtab == 'firing-notes'">My Notes </ion-item>
     </ion-list> -->
    <ion-segment (ionChange)="subTabChange($event)" value="program">
      <ion-segment-button value="program">
        <ion-label>
          {{ 'FIRING_HISTORY.PROGRAM' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="results-graph">
        <ion-label>
          {{ 'FIRING_HISTORY.GRAPH' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="firing-data">
        <ion-label>
          {{ 'FIRING_HISTORY.DATA' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="firing-notes">
        <ion-label>
          {{ 'FIRING_HISTORY.NOTES' | translate }}
        </ion-label>
      </ion-segment-button>
    </ion-segment>

    <div class="tab-body">
      <p>{{ 'FIRING_HISTORY.KILNLINK_FREE_MESSAGE' | translate }}</p>
    </div>
  </div>
  <div id="historical-firing-details" *ngIf="!viewingKilnlinkFreeKilns">
    <!-- <h6>Program Settings & End Results</h6> -->
    <!--  <ion-list class="tabs" *ngIf="!small_screen">
       <ion-item (click)="subtab = 'program'" [class.current]="subtab == 'program'">Program </ion-item>
       <ion-item (click)="subtab = 'results-graph'" [class.current]="subtab == 'results-graph'">Results Graph </ion-item>
       <ion-item (click)="subtab = 'firing-data'" [class.current]="subtab == 'firing-data'">Firing Data </ion-item>
       <ion-item (click)="subtab = 'firing-notes'" [class.current]="subtab == 'firing-notes'">My Notes </ion-item>
     </ion-list> -->
    <ion-segment (ionChange)="subTabChange($event)" value="program">
      <ion-segment-button value="program">
        <ion-label>
          {{ 'FIRING_HISTORY.PROGRAM' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="results-graph">
        <ion-label>
          {{ 'FIRING_HISTORY.GRAPH' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="firing-data">
        <ion-label>
          {{ 'FIRING_HISTORY.DATA' | translate }}
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="firing-notes">
        <ion-label>
          {{ 'FIRING_HISTORY.NOTES' | translate }}
        </ion-label>
      </ion-segment-button>
    </ion-segment>

    <div class="retreiving-firing-history" *ngIf="retrieving"><ion-spinner name="bubbles"></ion-spinner></div>
    <div class="error-firing-history" *ngIf="!retrieving && !error && (firing_history && firing_history.length === 0)">{{ 'FIRING_HISTORY.NO_AVAILABLE_HISTORY' | translate }}</div>
    <p class="full-width error-firing-history" *ngIf="error">{{ 'FIRING_HISTORY.ERROR_RETRIEVING_HISTORY' | translate }}</p>
    <div *ngIf="subtab == 'program' && !retrieving" class="tab-body">
      <ion-card class="header" *ngIf="details && details.program && details.config && !small_screen">        
        <ion-card-header>
          <ion-card-title>{{details.program.name || '-'}}</ion-card-title>          
          <ion-card-subtitle *ngIf="hasEnded(details)">{{ details.createdAt | date:'short' }} - {{ details.updatedAt | date:'short' }}</ion-card-subtitle>
          <ion-card-subtitle *ngIf="!hasEnded(details)">{{ details.createdAt | date:'short' }} - {{ 'FIRING_HISTORY.STILL_FIRING' | translate }}</ion-card-subtitle>
        </ion-card-header>
      </ion-card>
      <ion-card  *ngIf="details && details.program && details.config">        
        <ion-card-header>
          <ion-card-subtitle>{{ 'FIRING_HISTORY.DETAILS' | translate }}</ion-card-subtitle>          
        </ion-card-header>
        <ion-card-content>
          <ion-grid>
            <ion-row *ngIf="small_screen"><ion-col>{{ 'FIRING_HISTORY.START_DATE_TIME' | translate }}</ion-col><ion-col>{{ details.createdAt | date:'short' }}</ion-col></ion-row>
            <ion-row *ngIf="small_screen">
              <ion-col>{{ 'FIRING_HISTORY.END_DATE_TIME' | translate }}</ion-col>
              <ion-col *ngIf="hasEnded(details)">{{ details.updatedAt | date:'short' }}</ion-col>
              <ion-col *ngIf="!hasEnded(details)">----</ion-col>
            </ion-row>            
            <ion-row *ngIf="small_screen"><ion-col>{{ 'FIRING_HISTORY.PROGRAM_NAME' | translate }}</ion-col><ion-col>{{details.program && details.program.name || ('KILN_LIST.NO_DATA' | translate)}}</ion-col></ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.ELAPSED_FIRING_TIME' | translate }}</ion-col><ion-col>{{ getElapsedTime(details) }}</ion-col></ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.CONE' | translate }}</ion-col><ion-col>{{details.program.cone}}</ion-col></ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.FIRING_SPEED' | translate }}</ion-col><ion-col>{{details.program.speed}}</ion-col></ion-row>
            <!-- <ion-row><ion-col>Delay:</ion-col><ion-col>TBD</ion-col></ion-row> -->
            <ion-row><ion-col>{{ 'FIRING_HISTORY.ALARM' | translate }}</ion-col><ion-col>{{details.program.alarm_t}}</ion-col></ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.ERROR_CODES' | translate }}</ion-col><ion-col>{{details.config.err_codes}}</ion-col></ion-row>
            <ion-row>
              <ion-col>{{ 'FIRING_HISTORY.FINAL_STATUS' | translate }}</ion-col>
              <ion-col *ngIf="hasEnded(details)">{{details.final_status || '-'}}</ion-col>
              <ion-col *ngIf="!hasEnded(details)">---</ion-col>
            </ion-row>
            <ion-row>
              <ion-col>{{ 'FIRING_HISTORY.MAX_RECORDED_TEMPERATURE' | translate }}</ion-col>
              <ion-col>{{details.program.max_temp}}</ion-col>
            </ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.COST' | translate }}</ion-col>
              <ion-col *ngIf="details.cost">{{details.cost | currency:'USD':true:'1.2-2' }}</ion-col>
              <ion-col *ngIf="!details.cost">$0.00</ion-col>
            </ion-row>
            <ion-row><ion-col>{{ 'FIRING_HISTORY.FIRING_COUNTER' | translate }}</ion-col><ion-col>{{ details.statuses && details.statuses.length > 0 ? details.statuses[0].num_fire : ('KILN_LIST.NO_DATA' | translate) }}</ion-col></ion-row>
          </ion-grid>
      </ion-card-content>
    </ion-card>

    <ion-card>
      <ion-card-header class="program-card-header">
        <ion-card-subtitle>{{ 'FIRING_HISTORY.PROGRAM' | translate }}</ion-card-subtitle>
        <ion-button
          *ngIf="isHistoryDownloadToggleEnabled() && details?.program?.steps?.length > 0"
          class="program-csv-email-btn"
          fill="outline"
          color="primary"
          size="small"
          [disabled]="requestingProgramCsv"
          (click)="requestProgramCsvEmail()">
          <ion-spinner *ngIf="requestingProgramCsv" name="crescent" slot="start"></ion-spinner>
          <ion-icon *ngIf="!requestingProgramCsv" name="download-outline" slot="start"></ion-icon>
          {{ requestingProgramCsv ? ('FIRING_HISTORY.PROGRAM_CSV_REQUESTING' | translate) : ('FIRING_HISTORY.EMAIL_PROGRAM_CSV' | translate) }}
        </ion-button>
      </ion-card-header>
      <ion-card-content>
        <ion-grid *ngIf="details && details.program && details.program.steps && details.program.steps.length > 0">
            <ion-row>
              <ion-col>{{ 'FIRING_HISTORY.SEGMENT' | translate }}</ion-col>
              <ion-col>{{ 'FIRING_HISTORY.RAMP' | translate }}</ion-col>
              <ion-col>{{ 'FIRING_HISTORY.TEMP' | translate }}</ion-col>
              <ion-col>{{ 'FIRING_HISTORY.HOLD' | translate }}</ion-col>
            </ion-row>
            <ion-row *ngFor="let step of details.program.steps; index as i;">
              <ion-col>{{step.num}}</ion-col>
              <ion-col>{{step.rt}}</ion-col>
              <ion-col>{{step.t}}</ion-col>
              <ion-col>{{getHour(details, step)}}:{{step.mn.toString().padStart(2, '0')}}</ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </ion-card>

      <ion-card>
        <ion-card-header>
          <ion-card-subtitle>{{ 'FIRING_HISTORY.STEPS' | translate }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-grid *ngIf="program_steps && program_steps.length > 0">
              <ion-row>
                <ion-col>{{ 'FIRING_HISTORY.SEGMENT' | translate }}</ion-col>
                <ion-col>{{ 'FIRING_HISTORY.START_TIME' | translate }}</ion-col>
                <ion-col>{{ 'FIRING_HISTORY.END_TIME' | translate }}</ion-col>
              </ion-row>
              <ion-row *ngFor="let step of program_steps; index as i;">
                <ion-col>{{step.name}}</ion-col>
                <ion-col *ngIf="step.start_time !== '---'">{{step.start_time | date:'short'}}</ion-col>
                <ion-col *ngIf="step.start_time === '---'">{{step.start_time}}</ion-col>
                <ion-col *ngIf="step.end_time !== '---'">{{((step.name && step.name.includes('Hold') && (program_steps[i+1] !== undefined && program_steps[i+1] !== null)) ? program_steps[i+1].start_time : step.end_time) | date:'short'}}</ion-col>
                <ion-col *ngIf="step.end_time === '---'">{{step.end_time}}</ion-col>
              </ion-row>
              <ion-row *ngIf="program_steps && program_steps.length < 4" class='empty'></ion-row>
              <ion-row *ngIf="program_steps && program_steps.length < 3" class='empty'></ion-row>
            </ion-grid>
        </ion-card-content>
      </ion-card>

    </div>

    <div *ngIf="subtab == 'results-graph' && details && details.statuses && details.statuses.length > 0" class="tab-body graph">
      <app-firing-graph [zones]="details.config ? details.config.num_zones : 1" 
        [dataLength]="details.statuses ? details.statuses.length : 0"
        [data]="details.statuses" [maxWidth]="graphDimensions.width" [maxHeight]="graphDimensions.height" [smallScreen]="small_screen">
      </app-firing-graph>
    </div>
    <div *ngIf="subtab == 'firing-data' && details" class="details-table tab-body firing-data-tab">
      <ion-grid class="firing-data-table" *ngIf="details.statuses && details.statuses.length > 0">
        <ion-row class="header">
          <ion-col class="col-date">{{ 'FIRING_HISTORY.DATE' | translate }}</ion-col>
          <ion-col class="col-fire-time">{{ 'FIRING_HISTORY.FIRE_TIME' | translate }}</ion-col>
          <ion-col class="col-step">{{ 'FIRING_HISTORY.STEP' | translate }}</ion-col>
          <ion-col class="col-set-point">{{ 'FIRING_HISTORY.SET_POINT' | translate }}</ion-col>
          <ion-col class="col-zone" *ngIf="details.config.num_zones>=2">{{ 'FIRING_HISTORY.ZONE_1' | translate }}</ion-col>
          <ion-col class="col-zone">{{ 'FIRING_HISTORY.ZONE_2' | translate }}</ion-col>
          <ion-col class="col-zone" *ngIf="details.config.num_zones>=3">{{ 'FIRING_HISTORY.ZONE_3' | translate }}</ion-col>
          <ion-col class="col-board-temp">{{ 'FIRING_HISTORY.BOARD_TEMP' | translate }}</ion-col>
        </ion-row>
        <ion-row *ngFor="let status of details.statuses">
          <ion-col class="col-date">{{(status.createdAt || status.date) | date:'short'}}</ion-col>
          <ion-col class="col-fire-time" *ngIf="status.mode === 'Firing'">{{status.fire_hour}}h{{status.fire_min}}m</ion-col>
          <ion-col class="col-fire-time" *ngIf="status.mode !== 'Firing'">-</ion-col>
          <ion-col class="col-step">{{status.step}}</ion-col>
          <ion-col class="col-set-point">{{status.set_pt}}</ion-col>
          <ion-col class="col-zone" *ngIf="details.config.num_zones>=2">{{status.t1}}</ion-col>
          <ion-col class="col-zone">{{status.t2}}</ion-col>
          <ion-col class="col-zone" *ngIf="details.config.num_zones>=3">{{status.t3}}</ion-col>
          <ion-col class="col-board-temp">{{status.board_t}}</ion-col>
        </ion-row>
      </ion-grid>
      <div class="firing-data-csv-actions" *ngIf="isHistoryDownloadToggleEnabled() && details.statuses && details.statuses.length > 0">
        <ion-button
          class="firing-data-csv-btn"
          fill="outline"
          color="primary"
          size="small"
          (click)="downloadFiringDataCsv()">
          <ion-icon name="download-outline" slot="start"></ion-icon>
          {{ 'FIRING_HISTORY.DOWNLOAD_FIRING_DATA_CSV' | translate }}
        </ion-button>
      </div>
    </div>
    <div *ngIf="subtab == 'firing-notes' && selected_firing" class="tab-body">
      <form [formGroup]="firingNotesForm" class="firing-notes-form" (ngSubmit)="submitFiringNote(firingNotesForm.value)">
        <ion-item>
          <ion-label>{{ 'FIRING_HISTORY.LOAD_DENSITY' | translate }}</ion-label>
          <ion-input formControlName="load_density" ></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'FIRING_HISTORY.LOAD_DESCRIPTION' | translate }}</ion-label>
          <ion-input formControlName="load_description"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'FIRING_HISTORY.COMMENTS' | translate }}</ion-label>
          <ion-textarea formControlName="comments"></ion-textarea>
        </ion-item>

        <div class="buttons">
          <input *ngIf="!submittingNote && editingNote" type="submit" [value]="'FIRING_HISTORY.UPDATE' | translate"/>
          <input *ngIf="!submittingNote && !editingNote" type="submit" [value]="'FIRING_HISTORY.SUBMIT' | translate"/>
          <button *ngIf="submittingNote"><ion-spinner name="bubbles"></ion-spinner></button>
        </div>
      </form>
    </div>
  </div>
</div>
